import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostCommentsFailed, EGetPostCommentsActionType } from './types';

export const getPostCommentsFailed: () => TGetPostCommentsFailed = actionGenerator<EGetPostCommentsActionType.Failed>(
  EGetPostCommentsActionType.Failed,
);
